import {find, findIn, findAll, on} from '@elements/dom-utils';
import {onFind, findAllIn} from "@elements/init-modules-in-scope";

const defaultSelectors = {
    base: '.js-service-teaser__detail-datepicker',
    reset: '.js-datepicker-reset',
    input: '.js-datepicker__input',
    value: '.js-datepicker__alt-field',
};

export function init(selectors = defaultSelectors) {

    onFind(selectors.base, function (baseElement) {
        let value = findIn(selectors.value, baseElement);
        let input = findIn(selectors.input, baseElement);
        let reset = findIn(selectors.reset, baseElement);

        input.addEventListener('blur', () => {
            setTimeout(function () {
                if (input.value !== '') {
                    reset.classList.add('visible');
                }
            }, 125);
        });

        reset.addEventListener("click", () => {
            value.setAttribute('value', '');
            input.value = null;
            reset.classList.remove('visible');
        })
    })
}